export default function () {
  const widgetName = "mainSlider";
  const widgetOpts = mainSliderOpts;

  const swiperContainers = `
        <div class="swiper-container swiper-container-images">
        <div class="swiper-wrapper">
        </div>
      </div>
      <div class="swiper-container swiper-container-content">
        <div class="swiper-wrapper">
        </div>
      </div>
      
    `;

  const swiperLeftArrow = `
  <svg xmlns="http://www.w3.org/2000/svg" height="40" width="20" fill="#fff200" viewBox="0 0 256 512">
  <path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"/></svg>
  `;

  const swiperRightArrow = `
  <svg xmlns="http://www.w3.org/2000/svg" height="40" width="20" fill="#fff200" viewBox="0 0 256 512">
  <path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"/></svg>
  `;
  // Slide Template - Images
  function buildSlideTemplate(slide) {
    const title = `<h2>${slide.Title.slice(0, 50)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : "";

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn1) {
          btnContainer.append(
            `<a href="${btn1}" class="button">${btn1Text}</a>`
          );
        }

        if (btn2) {
          btnContainer.append(
            `<a href="${btn2}" class="button">${btn2Text}</a>`
          );
        }

        return btnContainer.prop("outerHTML");
      } else {
        return "";
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${
          slide.ImageWithPath
        }" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
        <div class="swiper-content-container">
          <div class="swiper-arrows__button swiper-arrows__button--prev" >
            ${swiperLeftArrow}
          </div>
          <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
          <div class="swiper-content-text">
            ${title}
            ${description}
            ${buttons(
              slide.URL,
              slide.DetailLinkText,
              slide.PurchaseURL,
              slide.PurchaseLinkText
            )}
          </div>
          <div class="swiper-arrows__button swiper-arrows__button--next" >
          ${swiperRightArrow}
        </div>
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(
      `#${widgetName} .swiper-container-images .swiper-wrapper`
    );
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`
    );

    widgetData.forEach(function (slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidgetImages = new Swiper(
      `#${widgetName} .swiper-container-images`,
      {
        speed: 600,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        loop: widgetData.length > 1 ? true : false,
        watchOverflow: true,
        spaceBetween: 0,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        a11y: true,
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          enabled:
            widgetData.length > 1 ? true : $(".swiper-arrows__button").remove(),
          nextEl: `#${widgetName} .swiper-arrows__button--next`,
          prevEl: `#${widgetName} .swiper-arrows__button--prev`,
        },
        pagination: {
          enabled:
            widgetData.length > 1 ? true : $(".swiper-pagination").remove(),
          el: `#${widgetName} .swiper-pagination`,
          clickable: true,
        },
      }
    );

    const swiperWidgetContent = new Swiper(
      `#${widgetName} .swiper-container-content`,
      {
        speed: 600,
        spaceBetween: 0,
        centeredSlides: false,
        loop: widgetData.length > 1 ? true : false,
        a11y: true,
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      }
    );
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then((response) => {
    const eventsMode = $("body").hasClass("eventsMode");
    if (eventsMode) {
      if (response.Slides.length > 0) {
        $(`#${widgetName}`).html(swiperContainers);
        initSwiper(response.Slides);
      } else {
        $("#mainSlider").remove();
      }
    } else {
      $("#mainSlider").remove();
      $("#main-feature-section").append(`
        <div id="htmlVideoContainer">
          <video muted="" playsinline="" autoplay="" loop="" poster="" role="presentation" id="hero-video">
            <source src="${FULLCLIENTTHEMEPATH}static/TheBigE2024Recap-2.mp4?sv=${SITEVERSION} type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
       `);
    }
  });
}
